import React from "react";
import * as EncryBase from "../../wea-tools/Encry.base";
const { Encry } = EncryBase;
class Main extends React.Component {
  render() {
    return (
      <Encry
        {...this.props}
        prefixCls="wea-textarea-auth"
        ecId={`${this.props.ecId}_Encry@95do1g`}
      />
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./ecology9/base/wea-textarea-auth/index.js